// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2024-2025 (original work) Open Assessment Technologies SA ;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { FEATURE_CANDIDATES } from '@/constants/features.js';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard.js';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard.js';
import { multiGuard } from '@/core/guards/guardComposer.js';

export const routing = [
    {
        path: [config.routes.candidates.candidate],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_CANDIDATES),
            getPermissionsGuard([{ resource: 'portal.candidate', scopes: ['view'] }])
        ]),
        controller: () => import('./controllers/candidateOverview')
    },
    {
        path: [config.routes.candidates.candidateIntegration],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_CANDIDATES),
            getPermissionsGuard([{ resource: 'portal.candidate', scopes: ['view'] }]),
            getPermissionsGuard([{ resource: 'portal.candidate', scopes: ['create-integration-user'] }])
        ]),
        controller: () => import('./controllers/candidateIntegration')
    }
];
